import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { format } from "date-fns";
import "./ModuleContract.css";
import DatePicker from "react-datepicker";
import { es } from "date-fns/locale";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import WarningNotification from "../../components/Notifications/WarningNotification";
import NotificationConnectionKpi from '../../components/Notifications/NotificationConnectionKpi';
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-datepicker/dist/react-datepicker.css";
import {
  faSave,
  faRotate,
  faCircleArrowLeft,
  faXmark,
  faEyeSlash,
  faEye
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";
import Select from "react-select";
import Loader from "../../components/Loader";
import AddWhatsAppTemplatePermissions from "../../components/AddWhatsAppTemplatePermissions";

const ModuleContract = ({ handleLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const moduleId = searchParams.get("moduleId");
  const contract = process.env.REACT_APP_FENIX_CONTRACT;
  const [distributors, setDistributors] = useState([]);
  const [numContId, setContId] = useState(
    moduleId ? '' : location.state?.modules?.numCont || "");
  const [modulo, setCodigo] = useState("");
  const [numLicencias, setNumLicencias] = useState(1);
  const [fechaFin, setFechaFin] = useState(null);
  const [activo, setIsActive] = useState(false);
  const [isDisconnected, setIsDisconnected] = useState(0);
  const [motivo, setMotivo] = useState("");
  const [isPay, setIsPay] = useState(0);
  const [maxCount, setMaxCount] = useState("");
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isInfoVisible, setIsInfoVisible] = useState(false);
  const [errorsMessage, setErrorMessage] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [isWarningVisible, setIsWarningVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const role = localStorage.getItem('role');
  const distributorToken = localStorage.getItem('distributor');
  const [canal, setCanal] = useState(role !== 'SUPER_ADMIN' && role !== 'ADMIN' ? distributorToken : distributorToken);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [distribuidorComparate, setDistributor] = useState('');
  const [ruc, setCif] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [name, setNombre] = useState("");
  const [lastName, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmarClave, setConfirmarClave] = useState("");
  const [userName, setUserName] = useState("");
  const [moduleTemplatesId, setModuleTemplatesId] = useState("");
  const [planId, setPlanId] = useState("");
  const [month, setMonth] = useState("");
  const [options, setOptions] = useState([]);
  const [mensaje, setMensaje] = useState(0);
  const [isSuccessNotifVisible, setIsSuccessNotifVisible] = useState(false);
  const [notificationWhatsApp, setNotificationWhatsApp] = useState(false);
  const [messageBlock, setMessageBlock] = useState(false);
  const [isWhatsappPoliza, setIsWhatsapp] = useState(false);
  const [planDescrip, setPlanDescrip] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [accountType, setAccountType] = useState("");
  const [cloudPhoneNumberId, setCloudPhoneNumberId] = useState("");
  const [cloudAppId, setCloudAppId] = useState("");
  const [cloudAccessToken, setCloudAccessToken] = useState("");
  const [cloudAppSecret, setCloudAppSecret] = useState("");
  const [cloudDefaultTemplateName, setCloudDefaultTemplateName] = useState("");
  const [cloudDefaultTemplateLanguage, setCloudDefaultTemplateLanguage] = useState("");
  const [cloudWabaId, setCloudWabaId] = useState("");
  const [templatePermissions, setTemplatePermissions] = useState("");
  const [idRegistro, setIdRegistro] = useState(0);
  const [makiId, setMakiId] = useState(0);

  const toggleSwitch = () => {
    setIsActive((prev) => !prev);
  };

  const toggleSwitch2 = () => {
    setIsDisconnected((prev) => !prev);
  };

  const isHandleCloseSuccess = () => {
    setIsSuccessNotifVisible(false);
    setTemplatePermissions(true);
    //navigate(-1);
  };

  const closeWhatsappPermisionsModal = () => {
    setTemplatePermissions(false);
    navigate(-1);
  };

  const validateFields = () => {
    let validationErrors = {};
    if (!numContId) validationErrors.numContId = "El Campo es Obligatorio";
    if (!modulo) validationErrors.modulo = "El Campo es Obligatorio";
    if (!numLicencias) validationErrors.numLicencias = "El Campo es Obligatorio";
    if (!canal) validationErrors.canal = "El Campo es Obligatorio";
    if (!fechaFin) validationErrors.fechaFin = "El Campo es Obligatorio";
    if (!isPay) validationErrors.isPay = "El Campo es Obligatorio";
    if (!maxCount) validationErrors.maxCount = "El Campo es Obligatorio";
    return validationErrors;
  };


  const validateFieldsWhatsApp = () => {
    let validationErrors = {};
    if (!ruc) validationErrors.ruc = "El Campo es Obligatorio";
    if (!phoneNumber) validationErrors.phoneNumber = "El Campo es Obligatorio";
    if (!name) validationErrors.name = "El Campo es Obligatorio";
    if (!lastName) validationErrors.lastName = "El Campo es Obligatorio";
    if (!email) validationErrors.email = "El Campo es Obligatorio";
    if (!userName) validationErrors.userName = "El Campo es Obligatorio";
    if (!moduleTemplatesId) validationErrors.moduleTemplatesId = "El Campo es Obligatorio";
    if (!password) validationErrors.password = "El Campo es Obligatorio";
    if (password !== confirmarClave) {
      validationErrors.confirmarClave = "Las claves no coinciden";
    }
    if (serviceType === "cloud") {
      if (!cloudPhoneNumberId) validationErrors.cloudPhoneNumberId = "El Campo es Obligatorio";
    }
    if (accountType === "custormer_private") {
      if (!cloudAppId) validationErrors.cloudAppId = "El Campo es Obligatorio";
      if (!cloudAccessToken) validationErrors.cloudAccessToken = "El Campo es Obligatorio";
      if (!cloudAppSecret) validationErrors.cloudAppSecret = "El Campo es Obligatorio";
      if (!cloudDefaultTemplateName) validationErrors.cloudDefaultTemplateName = "El Campo es Obligatorio";
      if (!cloudDefaultTemplateLanguage) validationErrors.cloudDefaultTemplateLanguage = "El Campo es Obligatorio";
      if (!cloudWabaId) validationErrors.cloudWabaId = "El Campo es Obligatorio";
    }
    return validationErrors;
  };


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await apiClient.get("/products");
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  //OPCIONES WHATSAPP
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await apiClient.get("/module_pack?productType=SUBSCRIPTIONS&moduleCode=WHATSAPP");
        const formattedOptions = response.data.map((item) => ({
          value: item.id.toString(),
          label: item.description,
          makiSubscriptionsId: item.makiSubscriptionsId,
          paymentPeriod: item.paymentPeriod,
        }));
        setOptions(formattedOptions);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    fetchOptions();
  }, []);

  const handleWhatsAppChange = (selectedOption) => {
    if (selectedOption) {
      setModuleTemplatesId(selectedOption.value); // id
      setPlanId(selectedOption.makiSubscriptionsId); // planId
      setMonth(selectedOption.paymentPeriod); // meses
    } else {
      setModuleTemplatesId("");
      setPlanId("");
      setMonth("");
    }
  };

  useEffect(() => {
    const fetchDistributors = async () => {
      try {
        const response = await apiClient.get("/distributors");
        setDistributors(response.data);
      } catch (error) {
        console.error("Error fetching distributors:", error);
      }
    };

    //fetchData(); // Assuming fetchData is defined elsewhere and stable
    fetchDistributors();
  }, []); // Add 'fetchData' to the dependency array


  const handleClick = () => {
    navigate(-1);
  };

  const handleDateChange = (date) => {
    // Convierte la fecha seleccionada al formato YYYY-MM-DD HH:mm:ss
    const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss");
    setFechaFin(formattedDate);
  };

  const fetchAuthToken = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_CIFRUC_URL}/login`,
        {
          method: "GET",
          headers: {
            Authorization: "Basic " + btoa("fenix:7&m$T8v_12d6?aA}yVOF"),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al obtener el token");
      }

      const data = await response.json();
      return data.token;
    } catch (error) {
      console.error("Error al obtener el token:", error);
      return null;
    }
  };

  const handleDocumentSearch = async (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
      try {
        // Obtén el token primero
        setLoading(true);
        const token = await fetchAuthToken();
        if (!token) {
          throw new Error("No se pudo obtener el token de autenticación");
        }
        const response = await fetch(
          `${process.env.REACT_APP_CIFRUC_URL}/document/search`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              contract: contract,
              document: ruc,
            }),
          }
        );
        if (!response.ok) {
          throw new Error("Error en la búsqueda del documento");
        }
        const data = await response.json();
        if (data.document && data.document.socialReason) {
          setIsWarningVisible(false);
          setIsErrorVisible(false);
          setIsButtonDisabled(false);
          const palabras = data.document.socialReason.trim().split(/\s+/);
          const apellido = palabras.slice(0, 2).join(" ");
          const nombre = palabras.slice(-2).join(" ");
          setApellido(apellido);
          setNombre(nombre);
        }
        if (data.document && data.document.email) {
          setEmail(data.document.email);
        } else {
          setEmail("");
        }
      } catch (error) {
        setErrorMessage(
          "El Documento de Identificación ingresado es Incorrecto o No Existe."
        );
        setIsErrorVisible(true);
        setIsButtonDisabled(true);
        if (ruc.length === 10 && /^[0-9]+$/.test(ruc)) {
          setErrorMessage(
            "El Documento de Identificación ingresado es Incorrecto o No Existe."
          );
          setIsErrorVisible(true);
          setIsButtonDisabled(true);
        } else if (ruc.length === 13 && /^[0-9]+$/.test(ruc)) {
          setErrorMessage(
            "El Documento de Identificación ingresado es Incorrecto o No Existe."
          );
          setIsErrorVisible(true);
          setIsButtonDisabled(true);
        } else if (/[^0-9]/.test(ruc)) {
          setWarningMessage(
            "El Documento de Identificación ingresado es un Pasaporte."
          );
          setIsWarningVisible(true);
          setIsButtonDisabled(false);
        }

      } finally {
        setLoading(false);
      }
    }
  };
  const handleCifChange = (e) => {
    const value = e.target.value;
    setCif(value);
    if (value === "") {
      setNombre("");
      setApellido("");
      setEmail("");
      setIsWarningVisible(false);
      setIsErrorVisible(false);
      setIsButtonDisabled(false);
    }
  };

  const validateEmail = (email) => {
    // Expresión regular para validar el formato de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email); // Solo valida el formato del correo
  };
  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Validar el email
    if (!validateEmail(value)) {
      setErrors({
        email: 'Email inválido. Debe contener "@" y un dominio válido.',
      });
    } else {
      setErrors({});
    }
  };
  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const toggleShowPassword2 = () => {
    setShowPassword2((prevShowPassword) => !prevShowPassword);
  };

  const handleCloseBlock = () => {
    setMessageBlock(false);
  };
  useEffect(() => {
    if (moduleId) {
      const fetchModule = async () => {
        try {
          const response = await apiClient.get(`/modules/${moduleId}`);
          const fechaFin = response.data.fechaFin
            ? new Date(response.data.fechaFin)
            : null;
          setContId(response.data.numContId);
          setCodigo(response.data.modulo);
          setNumLicencias(response.data.numLicencias);
          setCanal(response.data.canal);
          setDistributor(response.data.canal);
          setFechaFin(fechaFin);
          setIsActive(response.data.activo === 1 ? true : false);
          setIsDisconnected(response.data.isDisconnected === 1 ? true : false);
          setMotivo(response.data.motivo);
          setIsPay(response.data.isPay === 1 ? "Pagado" : "Gratis");
          setMaxCount(response.data.maxCount);
          //AQUI PONER ALERTA WHATS
          if (modulo === "WHATSAPP") {
            setMessageBlock('Desde esta opción no puede editar la información relacionada con los planes de WhatsApp, para poder editar, acepte este mensaje y será redireccionado/a ha la opción correcta.')
            setNotificationWhatsApp(true);
          }
        } catch (error) {
          console.error("Error al cargar el modulo", error);
          if (error.response && error.response.status === 401) {
            setIsInfoVisible(true);
          }
        }
      };
      fetchModule();
    } else if (numContId) {
      setContId(numContId);
    }
  }, [moduleId, numContId, modulo]);

  const handleModuleChange = async (selectedOption) => {
    const newCodigo = selectedOption ? selectedOption.value : "";
    setCodigo(newCodigo);
    setIsWhatsapp(false);

    if (newCodigo.startsWith("POLIZA")) {
      try {
        const response = await apiClient.get(`/comboModule?search=${newCodigo}`);
        const comboResponse = response.data;
        const whatsappCombo = comboResponse.find(item => item.moduleCode === "WHATSAPP");

        if (whatsappCombo) {
          setIsWhatsapp(true);
          setModuleTemplatesId(whatsappCombo.whatsappTemplateId);

          const response2 = await apiClient.get(`/module_pack/${whatsappCombo.whatsappTemplateId}`);
          const whatsAppData = response2.data;

          if (Array.isArray(whatsAppData) && whatsAppData.length > 0) {
            setPlanDescrip(whatsAppData[0].description);
            setMonth(whatsAppData[0].paymentPeriod);
            setPlanId(whatsAppData[0].makiSubscriptionsId);
          }
        }
      } catch (error) {
        console.error("Error al cargar datos de WhatsApp:", error);
      }
    }
  };


  const handleDistributorChange = (selectedOption) => {
    setCanal(selectedOption ? selectedOption.value : "");
  };
  const handleSave = async () => {
    const validationErrors = validateFields();
    const today = new Date();
    const formattedDate = format(today, "yyyy-MM-dd HH:mm:ss");

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    let response;

    if (modulo === "WHATSAPP" || isWhatsappPoliza) {
      const validationErrors = validateFieldsWhatsApp();
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
      try {
        setLoading(true);
        const payloadWhatsApp = {
          moduleTemplatesId: String(moduleTemplatesId),
          numCont: numContId,
          userName,
          name,
          lastName,
          password,
          email,
          phoneNumber: "593" + phoneNumber,
          grupo: "user",
          platform: "whatsapp",
          planId,
          month,
          ruc,
          flagActive: true,
          fechaIni: formattedDate,
          serviceType,
          accountType,
          cloudPhoneNumberId,
          cloudAppId,
          cloudAccessToken,
          cloudAppSecret,
          cloudDefaultTemplateName,
          cloudDefaultTemplateLanguage,
          cloudWabaId
        };
        response = await apiClient.post("/whatsappDetails", payloadWhatsApp);
        if (response.status === 201) {
          const register = `Nro. Contrato: ${numContId}
          RUC: ${ruc}
          Razón Social: ${name + " " + lastName}
          Usuario: ${response.data?.userName}
Nro. Celular: ${response.data?.phoneNumber}
Contraseña: ${response.data?.password}
Token: ${response.data?.token}`;
          setMensaje(register);
          setIdRegistro(response.data?.id);
          setMakiId(response.data?.makiId);
          const payload = {
            numContId,
            modulo,
            canal,
            num_licencias: numLicencias,
            is_pay: isPay === "Pagado" ? true : false,
            max_count: maxCount,
            fechaFin
          };
          const payloadUpdate = {
            isPay: isPay === "Pagado" ? true : false,
            maxCount: maxCount,
            activo: activo === false ? false : true,
            motivo,
            fechaFin,
            fechaIni: formattedDate,
            numLicencias: numLicencias,
            canal
          };
          try {
            setLoading(true);
            if (moduleId) {
              // Modo edición: usar PATCH
              response = await apiClient.patch(
                `/modules/edit_by_contract/${numContId}/${modulo}`,
                payloadUpdate
              );
            } else {
              // Modo creación: usar POST
              response = await apiClient.post("/modules", payload);
            }
            setIsSuccessNotifVisible(true);
          } catch (error) {
            setIsErrorVisible(true);
            setIsSuccessVisible(false);
            setTimeout(() => {
              setIsErrorVisible(false);
            }, 4000);
          }
          finally {
            setLoading(false);
          }
        }
      } catch (error) {
        setIsErrorVisible(true);
        setIsSuccessVisible(false);
        setTimeout(() => {
          setIsErrorVisible(false);
        }, 4000);
      }


    }
    else {
      const payload = {
        numContId,
        modulo,
        canal,
        num_licencias: numLicencias,
        is_pay: isPay === "Pagado" ? true : false,
        max_count: maxCount,
        fechaFin,
        is_disconnected: isDisconnected === false ? false : true
      };
      const payloadUpdate = {
        isPay: isPay === "Pagado" ? true : false,
        maxCount: maxCount,
        activo: activo === false ? false : true,
        motivo,
        fechaFin,
        fechaIni: formattedDate,
        isDisconnected: isDisconnected === false ? false : true,
        numLicencias: numLicencias,
        canal
      };
      try {
        setLoading(true);
        if (moduleId) {
          // Modo edición: usar PATCH
          response = await apiClient.patch(
            `/modules/edit_by_contract/${numContId}/${modulo}`,
            payloadUpdate
          );
        } else {
          // Modo creación: usar POST
          response = await apiClient.post("/modules", payload);
        }
        setIsSuccessVisible(true);
        setIsErrorVisible(false);
        navigate(-1);
      } catch (error) {
        setIsErrorVisible(true);
        setIsSuccessVisible(false);
        setTimeout(() => {
          setIsErrorVisible(false);
        }, 4000);
      }
      finally {
        setLoading(false);
      }
    }

  };
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setIsPay(value);
    if (value === 'Pagado') {
      setMaxCount(999);
    } else if (value === 'Gratis') {
      setMaxCount(25);
    } else {
      setMaxCount(0); // Si ninguna opción está seleccionada
    }
  };
  return (
    <div className="home-container">
      <Header onLogout={handleLogout} title="Módulo por Contrato" />
      <Section>
        <div className="button-return-container">
          <FontAwesomeIcon
            className="basic-shortcut-icon"
            style={{ cursor: "pointer" }}
            icon={faCircleArrowLeft}
            onClick={handleClick}
          />
        </div>
      </Section>
      <div className="moduleNew-form-container">
        <h3 className="basic-info-form-title">Información del Módulo</h3>
        <div className="basic-info-form-grid">
          <div className="basic-info-form-group">
            <label style={{ color: errors.numContId ? "red" : "revert-layer" }}>Número de Contrato</label>
            <input
              type="text"
              placeholder="Contrato"
              value={numContId}
              onChange={(e) => setContId(e.target.value)}
              readOnly
            />
            {errors.numContId && <p className="error-message">{errors.numContId}</p>}
          </div>
          <div className="basic-info-form-group">
            <label style={{ color: errors.modulo ? "red" : "revert-layer" }}>Módulo</label>
            {!moduleId ? (
              <Select
                value={
                  modulo
                    ? {
                      value: modulo,
                      label: products.find(
                        (product) => product.codigo === modulo
                      )?.descripcion,
                    }
                    : null
                }
                onChange={handleModuleChange}
                options={products.map((product) => ({
                  value: product.codigo,
                  label: product.descripcion,
                }))}
                placeholder="Seleccione un módulo"
                isClearable
                classNamePrefix="custom-select"
                className="custom-select-container"
              />
            ) : (
              <input
                type="text"
                value={modulo}
                readOnly
              />
            )}

            {errors.modulo && <p className="error-message">{errors.modulo}</p>}
          </div>
          <div className="basic-info-form-group">
            <label style={{ color: errors.numLicencias ? "red" : "revert-layer" }}>Número de Licencias</label>
            <input
              type="text"
              placeholder="Número de Licencias"
              value={numLicencias}
              //onChange={(e) => setNumLicencias(e.target.value)}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setNumLicencias(value);
                }
              }}
            />
            {errors.numLicencias && <p className="error-message">{errors.numLicencias}</p>}
          </div>
          <div className="basic-info-form-group">
            <label style={{ color: errors.canal ? "red" : "revert-layer" }}>Distribuidor</label>
            {!moduleId ? (
              <Select
                value={
                  canal
                    ? {
                      value: canal,
                      label: distributors.find(
                        (distributor) => distributor.code === canal
                      )?.name,
                    }
                    : null
                }
                onChange={handleDistributorChange}
                options={distributors.map((distributor) => ({
                  value: distributor.code,
                  label: distributor.name,
                }))}
                placeholder="Seleccione un Distribuidor"
                isClearable // Para permitir limpiar la selección
                classNamePrefix="custom-select"
                className="custom-select-container"
              />
            ) : (
              distribuidorComparate === distributorToken ? (
                <Select
                  value={
                    canal
                      ? {
                        value: canal,
                        label: distributors.find(
                          (distributor) => distributor.code === canal
                        )?.name,
                      }
                      : null
                  }
                  onChange={handleDistributorChange}
                  options={distributors.map((distributor) => ({
                    value: distributor.code,
                    label: distributor.name,
                  }))}
                  placeholder="Seleccione un Distribuidor"
                  isClearable // Para permitir limpiar la selección
                  classNamePrefix="custom-select"
                  className="custom-select-container"
                />
              ) : (
                <input
                  type="text"
                  value={canal}
                  readOnly
                />
              )
            )}
            {errors.canal && <p className="error-message">{errors.canal}</p>}
          </div>
          <div className="basic-info-form-group">
            <label style={{ color: errors.isPay ? "red" : "revert-layer" }}>Plan</label>
            <select value={isPay} onChange={handleSelectChange}>
              <option value="">Seleccione una opción</option>
              <option value="Pagado">Pagado</option>
              <option value="Gratis">Gratis</option>
            </select>
            {errors.isPay && <p className="error-message">{errors.isPay}</p>}
          </div>
          {(isPay !== "" && (
            <div className="basic-info-form-group">
              <label style={{ color: errors.fechaFin ? "red" : "revert-layer" }}>Caduca</label>
              <DatePicker
                selected={fechaFin ? new Date(fechaFin) : null}
                onChange={handleDateChange}
                showTimeSelect
                locale={es}
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText="Selecciona la Fecha"
                className="custom-date-picker"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
              {errors.fechaFin && <p className="error-message">{errors.fechaFin}</p>}
            </div>))
          }
          <div className="basic-info-form-group">
            <label style={{ color: errors.maxCount ? "red" : "revert-layer" }}>Número Máximo de Registros</label>
            <input
              type="text"
              placeholder="Número Máximo de Registros"
              value={maxCount}
              //onChange={(e) => setMaxCount(e.target.value)}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,3}$/.test(value)) {
                  const numericValue = Number(value);

                  if (isPay === "Gratis" && numericValue <= 25) {
                    setMaxCount(value);
                  } else if (isPay === "Pagado" && numericValue <= 999) {
                    setMaxCount(value);
                  } else if (value === "") {
                    setMaxCount(""); // Permitir limpiar el campo
                  }
                }
              }}
            />
            {errors.maxCount && <p className="error-message">{errors.maxCount}</p>}
          </div>
          <div className="basic-info-form-group">
            <div className="basic-info-form-switch">
              <label>Desconectado</label>
              <div className="slider-container-contract" onClick={toggleSwitch2}>
                <div
                  className={`slider-option-contract ${isDisconnected
                    ? "active-contract"
                    : "inactive-contract"
                    }`}
                >
                  Sí
                </div>
                <div
                  className={`slider-option-contract ${!isDisconnected
                    ? "active-contract"
                    : "inactive-contract"
                    }`}
                >
                  No
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="basic-info-form-grid">
          {/* Solo renderizar si moduleId no es vacío */}
          {moduleId && (
            <div className="basic-info-form-group4">
              <label>Estado</label>
              <div className="slider-container" onClick={toggleSwitch}>
                <div className={`slider-option ${activo ? "active" : "inactive"}`}>
                  Activo
                </div>
                <div className={`slider-option ${!activo ? "active" : "inactive"}`}>
                  Inactivo
                </div>
              </div>
            </div>
          )}

          {/* Solo renderizar si moduleId no es vacío y activo es false */}
          {moduleId && !activo && (
            <div className="basic-info-form-group">
              <label>Motivo</label>
              <input
                type="text"
                placeholder="Motivo"
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
              />
            </div>
          )}
        </div>

        {!moduleId && (modulo === "WHATSAPP" || isWhatsappPoliza) && (
          <>
            <hr className="divider" />
            <h3 className="basic-info-form-title">Datos de Usario de WhatsApp</h3>
            <div className="basic-info-form-grid">
              <div className="basic-info-form-group">
                <label style={{ color: errors.ruc ? "red" : "revert-layer" }}>
                  Documento de Identificación
                </label>
                <input
                  type="text"
                  placeholder="Documento de Identificación"
                  value={ruc}
                  onChange={handleCifChange}
                  onKeyDown={handleDocumentSearch}
                />
                {errors.ruc && <p className="error-message">{errors.ruc}</p>}
              </div>
              <div className="basic-info-form-group">
                <label style={{ color: errors.name ? "red" : "revert-layer" }}>
                  Nombre
                </label>
                <input
                  type="text"
                  placeholder="Nombre"
                  value={name}
                  onChange={(e) => setNombre(e.target.value)}
                />
                {errors.name && <p className="error-message">{errors.name}</p>}
              </div>
              <div className="basic-info-form-group">
                <label style={{ color: errors.lastName ? "red" : "revert-layer" }}>
                  Apellido
                </label>
                <input
                  type="text"
                  placeholder="Apellido"
                  value={lastName}
                  onChange={(e) => setApellido(e.target.value)}
                />
                {errors.lastName && <p className="error-message">{errors.lastName}</p>}
              </div>
              <div className="basic-info-form-group">
                <label style={{ color: errors?.moduleTemplatesId ? "red" : "revert-layer" }}>Plan</label>
                {!isWhatsappPoliza ? (
                  <Select
                    value={
                      moduleTemplatesId
                        ? options.find((option) => option.value === moduleTemplatesId)
                        : null
                    }
                    onChange={handleWhatsAppChange}
                    options={options}
                    placeholder="Seleccione un módulo"
                    isClearable
                    classNamePrefix="custom-select"
                    className="custom-select-container"
                  />
                ) : (
                  <input
                    type="text"
                    value={planDescrip}
                    readOnly
                  />
                )}
                {errors?.moduleTemplatesId && <p className="error-message">{errors.moduleTemplatesId}</p>}
              </div>
              <div className="basic-info-form-group">
                <label style={{ color: errors?.phoneNumber ? "red" : "revert-layer" }}>Número de Celular</label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0 10px",
                      backgroundColor: "transparent",
                      border: "1px",
                      borderRight: "none",
                      borderRadius: "4px 0 0 4px"
                    }}
                  >
                    <img
                      src="https://flagcdn.com/w40/ec.png"
                      alt="EC"
                      style={{ width: "20px", height: "14px", marginRight: "6px" }}
                    />
                    +593
                  </span>
                  <input
                    type="text"
                    name="numeroCelular"
                    placeholder="Ej. 987654321"
                    className="form-control"
                    style={{ borderRadius: "0 4px 4px 0" }}
                    value={phoneNumber}
                    maxLength={9}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,9}$/.test(value)) {
                        setPhoneNumber(value);
                      }
                    }}
                  />
                </div>
                {errors?.phoneNumber && <p className="error-message">{errors.phoneNumber}</p>}
              </div>

              <div className="basic-info-form-group">
                <label style={{ color: errors.email ? "red" : "revert-layer" }}>
                  {" "}
                  Email
                </label>
                <input
                  type="text"
                  placeholder="Email"
                  value={email}
                  onChange={handleChange}
                />
                {errors.email && <p className="error-message">{errors.email}</p>}
              </div>
              <div className="basic-info-form-group">
                <label style={{ color: errors.userName ? "red" : "revert-layer" }}>
                  {" "}
                  Nombre de Usuario
                </label>
                <input
                  type="text"
                  placeholder="Nombre de Usuario"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
                {errors.userName && <p className="error-message">{errors.userName}</p>}
              </div>
              <div className="basic-info-form-group">
                <label style={{ color: errors.password ? "red" : "revert-layer" }}>
                  Clave
                </label>
                <div className="password-input-container">
                  <input
                    className="text-box-login2"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Contraseña"
                  />
                  <FontAwesomeIcon
                    icon={showPassword ? faEyeSlash : faEye}
                    className="password-toggle-icon2"
                    onClick={toggleShowPassword}
                  />
                </div>
                {errors.password && <p className="error-message">{errors.password}</p>}
              </div>
              <div className="basic-info-form-group">
                <label style={{ color: errors.confirmarClave ? "red" : "revert-layer" }}>
                  Confirmar Clave
                </label>
                <div className="password-input-container">
                  <input
                    className="text-box-login2"
                    type={showPassword2 ? "text" : "password"}
                    placeholder="Confirmar Clave"
                    value={confirmarClave}
                    onChange={(e) => setConfirmarClave(e.target.value)}
                  />
                  <FontAwesomeIcon
                    icon={showPassword2 ? faEyeSlash : faEye}
                    className="password-toggle-icon2"
                    onClick={toggleShowPassword2}
                  />
                </div>
                {errors.confirmarClave && <p className="error-message">{errors.confirmarClave}</p>}
              </div>
              <div className="basic-info-form-group">
                <label>Tipo</label>
                <select
                  value={serviceType}
                  onChange={(e) => setServiceType(e.target.value)}
                >
                  <option value="">Seleccione una opción</option>
                  <option value="web">Web</option>
                  <option value="cloud">Cloud</option>
                </select>
              </div>
              {serviceType === "cloud" && (
                <>
                  <div className="basic-info-form-group">
                    <label style={{ color: errors.cloudPhoneNumberId ? "red" : "revert-layer" }}>
                      ID Nro. Celular
                    </label>
                    <input
                      type="text"
                      placeholder="ID Nro. Celular"
                      value={cloudPhoneNumberId}
                      onChange={(e) => setCloudPhoneNumberId(e.target.value)}
                    />
                    {errors.cloudPhoneNumberId && <p className="error-message">{errors.cloudPhoneNumberId}</p>}
                  </div>
                  <div className="basic-info-form-group">
                    <label>Tipo Cuenta</label>
                    <select
                      value={accountType}
                      onChange={(e) => setAccountType(e.target.value)}
                    >
                      <option value="">Seleccione una opción</option>
                      <option value="custormer_private">Personal</option>
                      <option value="fnx_corporate">Corporativo</option>
                    </select>
                  </div>
                  {accountType === "custormer_private" && (
                    <>
                      <div className="basic-info-form-group">
                        <label style={{ color: errors.cloudAccessToken ? "red" : "revert-layer" }}>
                          Token
                        </label>
                        <input
                          type="text"
                          placeholder="Token"
                          value={cloudAccessToken}
                          onChange={(e) => setCloudAccessToken(e.target.value)}
                        />
                        {errors.cloudAccessToken && <p className="error-message">{errors.cloudAccessToken}</p>}
                      </div>
                      <div className="basic-info-form-group">
                        <label style={{ color: errors.cloudAppId ? "red" : "revert-layer" }}>
                          ID META
                        </label>
                        <input
                          type="text"
                          placeholder="id META"
                          value={cloudAppId}
                          onChange={(e) => setCloudAppId(e.target.value)}
                        />
                        {errors.cloudAppId && <p className="error-message">{errors.cloudAppId}</p>}
                      </div>
                      <div className="basic-info-form-group">
                        <label style={{ color: errors.cloudAppSecret ? "red" : "revert-layer" }}>
                          CLAVE META
                        </label>
                        <input
                          type="text"
                          placeholder="Clave META"
                          value={cloudAppSecret}
                          onChange={(e) => setCloudAppSecret(e.target.value)}
                        />
                        {errors.cloudAppSecret && <p className="error-message">{errors.cloudAppSecret}</p>}
                      </div>
                      <div className="basic-info-form-group">
                        <label style={{ color: errors.cloudDefaultTemplateName ? "red" : "revert-layer" }}>
                          Nombre Plantilla
                        </label>
                        <input
                          type="text"
                          placeholder="Nombre Plantilla"
                          value={cloudDefaultTemplateName}
                          onChange={(e) => setCloudDefaultTemplateName(e.target.value)}
                        />
                        {errors.cloudDefaultTemplateName && <p className="error-message">{errors.cloudDefaultTemplateName}</p>}
                      </div>
                      <div className="basic-info-form-group">
                        <label style={{ color: errors.cloudDefaultTemplateLanguage ? "red" : "revert-layer" }}>
                          Idioma Plantilla
                        </label>

                        <select
                          value={cloudDefaultTemplateLanguage}
                          onChange={(e) => setCloudDefaultTemplateLanguage(e.target.value)}
                        >
                          <option value="">Seleccione un idioma</option>
                          <option value="es">Español</option>
                          <option value="eng">Inglés</option>
                          <option value="por">Portugués</option>
                          <option value="fra">Francés</option>
                          <option value="deu">Alemán</option>
                          <option value="ita">Italiano</option>
                        </select>

                        {errors.cloudDefaultTemplateLanguage && (
                          <p className="error-message">{errors.cloudDefaultTemplateLanguage}</p>
                        )}
                      </div>
                      <div className="basic-info-form-group">
                        <label style={{ color: errors.dbHost ? "red" : "revert-layer" }}>
                          Id Cuenta Empresarial de WhatsApp
                        </label>
                        <input
                          type="text"
                          placeholder=" Id Cuenta Empresarial de WhatsApp"
                          value={cloudWabaId}
                          onChange={(e) => setCloudWabaId(e.target.value)}
                        />
                        {errors.dbHost && <p className="error-message">{errors.dbHost}</p>}
                      </div>


                    </>
                  )}

                </>
              )}


            </div>


          </>
        )}

        <div className="basic-form-footer">
          <button
            className="basic-custom-button"
            onClick={(e) => {
              e.stopPropagation();
              navigate(-1);
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
            Cancelar
          </button>
          <button className="basic-custom-button" onClick={handleSave} disabled={isButtonDisabled}>
            <FontAwesomeIcon
              icon={moduleId ? faRotate : faSave}
              className="basic-shortcut-icon"
            />
            {moduleId ? "Actualizar" : "Guardar"}
          </button>
        </div>
      </div>
      {loading && <Loader />}
      <SuccessNotification
        message={
          moduleId
            ? "El Módulo se ha Actualizado Correctamente."
            : "El Módulo se ha Creado Correctamente."
        }
        isVisible={isSuccessVisible}
        onClose={() => setIsSuccessVisible(false)}
      />

      <ErrorNotification
        message={errorsMessage}
        isVisible={isErrorVisible}
        onClose={() => setIsErrorVisible(false)}
      />
      <WarningNotification
        message={warningMessage}
        isVisible={isWarningVisible}
        onClose={() => setIsWarningVisible(false)}
      />
      <LoginNotification
        message="Vuele a iniciar sesión"
        isVisible={isInfoVisible}
        onClose={() => setIsInfoVisible(false)}
        onLogout={handleLogout}
      />
      <NotificationConnectionKpi
        message={`Los datos de conexión son:`}
        men1={mensaje}  // Pasando men1 como prop
        isVisible={isSuccessNotifVisible}
        onClose={isHandleCloseSuccess}
        enca={moduleId ? "Actualizado Correctamente" : false}
      />
      {notificationWhatsApp && (
        <SuccessProcess
          enca={true}
          message={messageBlock}
          isVisible={notificationWhatsApp}
          onClose={handleCloseBlock}
          redirectOnOk={true}
          pageNavigate={{ pathname: '/WhatsAppDetailsList', state: { contract: numContId } }}
          whatsApp={true}
        />
      )}
      {templatePermissions && (
        <AddWhatsAppTemplatePermissions
          isVisible={templatePermissions}
          onClose={() => closeWhatsappPermisionsModal()}
          id={idRegistro}
          makiId={makiId}
        />
      )}
    </div>
  );
};

export default ModuleContract;
